const WS = {
    URL_NOC: process.env.REACT_APP_URL_NOC || "http://localhost:3000/",
}

export default WS;